import { isMobileBreakpoint } from '@theme/utilities';

let groupCount = 0;

/**
 * Container element for the blob accordion. Rows render a section-scoped
 * `name` on their `<details>` for native exclusive-accordion behaviour; this
 * element rescopes that grouping per accordion instance (so sibling or nested
 * accordions in one section don't close each other), or strips it entirely
 * when the block's "Auto-close other rows" setting is off. Runs on every
 * (re)connect, so editor re-renders that restore the markup are re-adjusted.
 * Without JS the accordion falls back to section-wide auto-closing.
 */
class BlobAccordionGroup extends HTMLElement {
  /** Stable per-instance group name for the rescoped `name` attributes. */
  #groupName = `blob-accordion-${++groupCount}`;

  connectedCallback() {
    const autoClose = this.dataset.autoClose !== 'false';

    // Own rows only — a nested accordion adjusts its own grouping.
    for (const details of this.querySelectorAll('details[name]')) {
      if (details.closest('blob-accordion-group') !== this) continue;
      if (autoClose) details.setAttribute('name', this.#groupName);
      else details.removeAttribute('name');
    }

    // Re-assert open-by-default rows: accordion-custom (a head module) opened
    // them before this element adjusted the grouping, so under the shared
    // section-wide name each row's open closed the one before it.
    const openAttribute = isMobileBreakpoint() ? 'open-by-default-on-mobile' : 'open-by-default-on-desktop';
    for (const accordion of this.querySelectorAll(`accordion-custom[${openAttribute}]`)) {
      if (accordion.closest('blob-accordion-group') !== this) continue;
      const details = accordion.querySelector('details');
      if (details) details.open = true;
    }
  }
}

if (!customElements.get('blob-accordion-group')) {
  customElements.define('blob-accordion-group', BlobAccordionGroup);
}
